import { render, staticRenderFns } from "./Lable.vue?vue&type=template&id=0e1668a8&scoped=true&"
import script from "./Lable.vue?vue&type=script&lang=js&"
export * from "./Lable.vue?vue&type=script&lang=js&"
import style0 from "./Lable.vue?vue&type=style&index=0&id=0e1668a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1668a8",
  null
  
)

export default component.exports